import React, {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateText } from "../utils/translateText";
const OrderSuccess = () => {

  const navigate = useNavigate();

  const [orders, setOrders] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(false);
const { i18n } = useTranslation();

const [uiText, setUiText] = useState({});
  // ============================================
  // FETCH SUCCESS ORDERS
  // ============================================
  useEffect(() => {

    try {

      const storedOrders =
        localStorage.getItem(
          "success_orders"
        );

      console.log(
        "RAW STORAGE:",
        storedOrders
      );

      if (!storedOrders) {

        setError(true);
        setLoading(false);

        return;
      }

      const parsedOrders =
        JSON.parse(storedOrders);

      console.log(
        "PARSED ORDERS:",
        parsedOrders
      );

      // MULTIPLE ORDERS
      if (
        Array.isArray(parsedOrders)
      ) {

        setOrders(parsedOrders);

      }

      // SINGLE ORDER
      else if (
        parsedOrders &&
        typeof parsedOrders === "object"
      ) {

        setOrders([parsedOrders]);

      }

      else {

        setOrders([]);

      }

      // CLEAR STORAGE
      localStorage.removeItem(
        "success_orders"
      );

    } catch (err) {

      console.error(err);

      setError(true);

    } finally {

      setLoading(false);

    }

  }, []);

  // ============================================
  // ERROR REDIRECT
  // ============================================
  useEffect(() => {

    if (error) {

      console.log(
        "No order data"
      );

    }

  }, [error, navigate]);


  useEffect(() => {
  const loadTranslations = async () => {

    if (i18n.language !== "ar") {
      setUiText({
        loading: "Loading...",
        successTitle: "Order Placed Successfully 🎉",
        confirmed: "Your order has been confirmed",
        splitOrders:
          "Your cart was automatically split into multiple supplier orders.",
        noOrders: "No Orders Found",
        continueShopping: "Continue Shopping",
        supplier: "Supplier",
        supplierOrder: "Supplier Order",
        referenceId: "Reference ID",
        orderId: "Order ID",
        paymentMethod: "Payment Method",
        supplierAmount: "Supplier Amount",
        totalOrders: "Total Supplier Orders",
        grandTotal: "Grand Total",
        viewOrders: "View Orders"
      });

      return;
    }

    setUiText({
      loading: await translateText("Loading...", true),

      successTitle: await translateText(
        "Order Placed Successfully 🎉",
        true
      ),

      confirmed: await translateText(
        "Your order has been confirmed",
        true
      ),

      splitOrders: await translateText(
        "Your cart was automatically split into multiple supplier orders.",
        true
      ),

      noOrders: await translateText(
        "No Orders Found",
        true
      ),

      continueShopping: await translateText(
        "Continue Shopping",
        true
      ),

      supplier: await translateText(
        "Supplier",
        true
      ),

      supplierOrder: await translateText(
        "Supplier Order",
        true
      ),

      referenceId: await translateText(
        "Reference ID",
        true
      ),

      orderId: await translateText(
        "Order ID",
        true
      ),

      paymentMethod: await translateText(
        "Payment Method",
        true
      ),

      supplierAmount: await translateText(
        "Supplier Amount",
        true
      ),

      totalOrders: await translateText(
        "Total Supplier Orders",
        true
      ),

      grandTotal: await translateText(
        "Grand Total",
        true
      ),

      viewOrders: await translateText(
        "View Orders",
        true
      )
    });
  };

  loadTranslations();
}, [i18n.language]);


  // ============================================
  // LOADING
  // ============================================
  if (loading) {

    return (

      <h3
        style={{
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        {uiText.loading}
      </h3>

    );
  }

  // ============================================
  // EMPTY
  // ============================================
  if (!orders.length) {

    return (

      <section
        className="order_success_page"
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >

        <div className="success_card">

          <div className="success_icon">
            <i className="fas fa-check"></i>
          </div>

          
          <h2>{uiText.successTitle}</h2>
        

          <p>{uiText.confirmed}</p>

          <h5
            style={{
              color: "#ff6600"
            }}
          >
            {uiText.noOrders}
          </h5>

          <div className="success_actions">

            <Link
              to="/restaurantoffers"
              className="success_btn"
            >
              {uiText.continueShopping}
            </Link>

          </div>

        </div>

      </section>

    );
  }

  // ============================================
  // GRAND TOTAL
  // ============================================
  // const grandTotal =
  //   orders.reduce(
  //     (sum, o) =>
  //       sum +
  //       Number(
  //         o.amount || 0
  //       ),
  //     0
  //   ).toFixed(2);

  const paymentTotal = Number(
  localStorage.getItem("payment_total") || 0
).toFixed(2);
  return (

    <section className="order_success_page">

      <div className="success_card">

        {/* SUCCESS ICON */}
        <div className="success_icon">
          <i className="fas fa-check"></i>
        </div>

        {/* HEADER */}
        <h2>{uiText.successTitle}</h2>

        <p>{uiText.confirmed}</p>

        <p>{uiText.splitOrders}</p>

        {/* ========================================= */}
        {/* SUPPLIER ORDERS */}
        {/* ========================================= */}

        <div className="supplier_orders_wrapper">

          {orders.map((ord, index) => (

            <div
              key={index}
              className="supplier_order_card"
            >

              {/* TOP */}
              <div className="supplier_top">

                <h5>

                  {
                    ord?.supplier_name_english ||
                    uiText.supplier
                  }

                </h5>

                <span className="supplier_badge">

                  {uiText.supplierOrder}

                </span>

              </div>

              {/* DETAILS */}
              <div className="supplier_details">

              <p>
                {uiText.referenceId}:
                <span className="reference_id">
                  {orders[0]?.master_order_id}
                </span>
              </p>

               <p>
                  <b>{uiText.orderId}:</b>
                  #{ord?.order_id}
                </p>

                <p>
                  <b>{uiText.paymentMethod}:</b>
                  {ord?.payment_method || "COD"}
                </p>

                <p>
                  <b>{uiText.supplierAmount}:</b>
                  QAR {Number(ord?.amount || 0).toFixed(2)}
                </p>

              </div>

            </div>

          ))}

        </div>

        {/* ========================================= */}
        {/* SUMMARY */}
        {/* ========================================= */}

        <div className="success_summary">

          <h4>

            {uiText.totalOrders}:

            <span style={{
              color: "#ff6600"
            }}>

              {" "}
              {orders.length}

            </span>

          </h4>

          {/* <h3>

            {uiText.grandTotal}:

            <span style={{
              color: "#28a745"
            }}>

              {" "}
              QAR {grandTotal}

            </span>

          </h3> */}

          <h3>
  {uiText.grandTotal}:
  <span style={{ color: "#28a745" }}>
    {" "}
    QAR {paymentTotal}
  </span>
</h3>

        </div>

        {/* ========================================= */}
        {/* ACTIONS */}
        {/* ========================================= */}

        <div className="success_actions">

          <Link
            to="/restaurantoffers"
            className="success_btn"
          >
            {uiText.continueShopping}
          </Link>

          <Link
            to="/restaurantdashboard/orders"
            className="success_btn outline"
          >
            {uiText.viewOrders}
          </Link>

        </div>

      </div>

    </section>
  );
};

export default OrderSuccess;